import { render, staticRenderFns } from "./HelpNormal.vue?vue&type=template&id=1862d3ba&lang=pug&"
import script from "./HelpNormal.vue?vue&type=script&lang=ts&"
export * from "./HelpNormal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports